/**
 * Generated by orval v7.13.2 🍺
 * Do not edit manually.
 * API
 * OpenAPI spec version: 1.0.0
 */

export type GetApiListBookingDiscountsSortBy =
    (typeof GetApiListBookingDiscountsSortBy)[keyof typeof GetApiListBookingDiscountsSortBy];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetApiListBookingDiscountsSortBy = {
    code: 'code',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt',
    expiresAt: 'expiresAt',
    discountValue: 'discountValue',
    isActive: 'isActive',
    customerType: 'customerType',
} as const;
